import React, { lazy, Suspense } from "react";
import { RouteObject } from "react-router-dom";
import ProtectedRoute from "../components/feature/ProtectedRoute";

// Error boundary component for lazy loading
const LazyLoader = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div>Loading...</div>}>
    {children}
  </Suspense>
);

const Home = lazy(() => import("../pages/home/page"));
const Transfer = lazy(() => import("../pages/transfer/page"));
const PrivateTours = lazy(() => import("../pages/private-tours/page"));
const GroupTours = lazy(() => import("../pages/group-tours/page"));
const CarRental = lazy(() => import("../pages/car-rental/page"));
const VillaRental = lazy(() => import("../pages/villa-rental/page"));
const YachtRental = lazy(() => import("../pages/yacht-rental/page"));
const MyReservations = lazy(() => import("../pages/my-reservations/page"));
const Voucher = lazy(() => import("../pages/voucher/page"));
const Admin = lazy(() => import("../pages/admin/page"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const AdminLoginPage = lazy(() => import("../pages/admin-login/page"));
const About = lazy(() => import("../pages/about/page"));
const Blog = lazy(() => import("../pages/blog/page"));
const Contact = lazy(() => import("../pages/contact/page"));
const Services = lazy(() => import("../pages/services/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LazyLoader><Home /></LazyLoader>
  },
  {
    path: "/transfer",
    element: <LazyLoader><Transfer /></LazyLoader>
  },
  {
    path: "/private-tours",
    element: <LazyLoader><PrivateTours /></LazyLoader>
  },
  {
    path: "/group-tours",
    element: <LazyLoader><GroupTours /></LazyLoader>
  },
  {
    path: "/car-rental",
    element: <LazyLoader><CarRental /></LazyLoader>
  },
  {
    path: "/villa-rental",
    element: <LazyLoader><VillaRental /></LazyLoader>
  },
  {
    path: "/yacht-rental",
    element: <LazyLoader><YachtRental /></LazyLoader>
  },
  {
    path: "/my-reservations",
    element: <LazyLoader><MyReservations /></LazyLoader>
  },
  {
    path: "/voucher",
    element: <LazyLoader><Voucher /></LazyLoader>
  },
  {
    path: "/admin-login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/about",
    element: <LazyLoader><About /></LazyLoader>
  },
  {
    path: "/blog",
    element: <LazyLoader><Blog /></LazyLoader>
  },
  {
    path: "/contact",
    element: <LazyLoader><Contact /></LazyLoader>
  },
  {
    path: "/services",
    element: <LazyLoader><Services /></LazyLoader>
  },
  {
    path: "*",
    element: <LazyLoader><NotFound /></LazyLoader>
  }
];

export default routes;
